import { render, staticRenderFns } from "./edu-material-copy.vue?vue&type=template&id=5fbfc467&scoped=true&"
import script from "./edu-material-copy.vue?vue&type=script&lang=js&"
export * from "./edu-material-copy.vue?vue&type=script&lang=js&"
import style0 from "./edu-material-copy.vue?vue&type=style&index=0&id=5fbfc467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfc467",
  null
  
)

export default component.exports